/**
 * FileNotes — append-only progress log for a single CLIENT FILE.
 *
 * A thin adapter over the shared <NotesLog> engine: it wires the generic log to
 * the client-file notes store (fileNotesApi) and keeps the "File Notes" title.
 * All rendering, the 200-char input (NOTE_BODY_MAX, matching the file_notes DB
 * CHECK), and the §31 acknowledgement affordance live in NotesLog. The
 * acknowledger role pair for file notes is {Adviser, Administration Assistant}
 * (enforced in fileNotesApi).
 */

import NotesLog from '../shared/NotesLog';
import { getNotesForFile, createNote, acknowledgeNote, NOTE_BODY_MAX } from '../../api/fileNotesApi';

// Adapter mapping the generic NotesLog contract onto fileNotesApi. Defined once
// at module scope so its identity is stable across renders (NotesLog memoises
// its load/acknowledge callbacks on `api`).
const fileNotesAdapter = {
  getNotes: (fileId) => getNotesForFile(fileId),
  createNote: ({ itemId, ...rest }) => createNote({ fileId: itemId, ...rest }),
  acknowledgeNote: (noteId) => acknowledgeNote(noteId),
};

export default function FileNotes({ fileId, currentUser, currentRole = null, refreshSignal = 0 }) {
  return (
    <NotesLog
      itemId={fileId}
      api={fileNotesAdapter}
      title="File Notes"
      currentUser={currentUser}
      currentRole={currentRole}
      refreshSignal={refreshSignal}
      maxChars={NOTE_BODY_MAX}
    />
  );
}
